export default {
    "navigation": {
        "allWatchfaces": "Wszystkie aplikacje",
        "faq": "FAQ",
        "helpCenter": "Pomoc i instrukcje",
        "newsletter": "Newsletter",
        "contact": "Kontakt",
        "weatherProvider": "Dostawca Pogody",
        "tides": "Pływy",
        "colors": "Kolory",
        "fonts": "Czcionki"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Nowoczesne aplikacje Garmin z zaawansowanymi funkcjami do wszystkich Twoich aktywności",
        "newBadge": "Nowy",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Często zadawane pytania",
        "subtitle": "Znajdź odpowiedzi na częste pytania dotyczące naszych tarcz",
        "tabs": {
            "search": "Szukaj",
            "categories": "Kategorie",
            "trending": "Trending"
        },
        "search": {
            "placeholder": "Szukaj pomocy...",
            "button": "Szukaj",
            "suggestions": "Popularne wyszukiwania",
            "tips": {
                "title": "Wskazówki wyszukiwania",
                "keywords": "Używaj konkretnych słów kluczowych jak \"GPS\", \"pogoda\" lub \"ustawienia\"",
                "language": "Wyszukiwanie działa w wybranym języku",
                "categories": "Przeglądaj kategorie dla zorganizowanej pomocy"
            }
        },
        "noResults": {
            "title": "Nie znaleziono wyników",
            "description": "Spróbuj innych słów kluczowych lub przeglądaj kategorie",
            "browseCategories": "Przeglądaj kategorie"
        },
        "suggestions": {
            "title": "Popularne wyszukiwania"
        },
        "trending": {
            "title": "Trending wyszukiwania"
        },
        "categories": {
            "title": "Przeglądaj według kategorii",
            "items": "elementy",
            "allItems": "Wszystkie elementy FAQ",
            "allItemsDescription": "Przeglądaj wszystkie często zadawane pytania",
            "noItems": {
                "title": "Brak elementów w tej kategorii",
                "description": "Spróbuj wybrać inną kategorię"
            },
            "viewMore": "Zobacz wszystkie elementy"
        },
        "results": {
            "title": "Wyniki wyszukiwania",
            "found": "wyników znaleziono dla",
            "total": "Łączne wyniki",
            "bestMatch": "Najlepsze dopasowanie",
            "categories": "Kategorie",
            "sortBy": "Sortuj według",
            "sort": {
                "relevance": "Trafność",
                "priority": "Priorytet",
                "category": "Kategoria"
            },
            "lastUpdated": "Ostatnio zaktualizowano",
            "matchedIn": "Dopasowanie w",
            "footer": "Nie znalazłeś tego, czego szukałeś?",
            "browseCategories": "Przeglądaj kategorie",
            "viewTrending": "Zobacz trending",
            "contactSupport": "Skontaktuj się z pomocą"
        },
        "actions": {
            "copy": "Kopiuj",
            "share": "Udostępnij",
            "copyAnswer": "Kopiuj odpowiedź",
            "copyAll": "Kopiuj wszystko"
        },
        "loading": "Ładowanie FAQ...",
        "error": "Błąd ładowania",
        "retry": "Spróbuj ponownie"
    },
    "guides": {
        "backToHelp": "Wstecz",
        "purchase": {
            "title": "Zakup i instalacja",
            "tabs": {
                "installation": "Instalacja",
                "versions": "Wersje VX / Elite",
                "troubleshooting": "Rozwiązywanie problemów"
            },
            "installation": {
                "title": "Instalacja tarcz przez aplikację ConnectIQ",
                "intro": "Tarcze można instalować na zegarku przez aplikację Garmin ConnectIQ na Androidzie lub iOS.",
                "step1": "Połącz zegarek z telefonem przez Bluetooth i otwórz aplikację ConnectIQ na telefonie.",
                "step2": "Przejdź do strony tarczy, którą chcesz zainstalować.",
                "step3": "Dotknij przycisku \"Zainstaluj\". Tarcza trafi do kolejki i zostanie zainstalowana na zegarku.",
                "step4": "Po instalacji zobaczysz komunikat w aplikacji lub na zegarku, a tarcza będzie dostępna na urządzeniu.",
                "noteScreen": "Upewnij się, że ekran telefonu się nie wyłącza i że aplikacja ConnectIQ pozostaje otwarta podczas instalacji i aktualizacji.",
                "selectWatchfaceTitle": "Wybór tarczy na zegarku",
                "selectWatchfaceIntro": "Jeśli tarcza jest zainstalowana, ale jeszcze niewidoczna, może być konieczny jej wybór w menu systemowym zegarka.",
                "select1": "Naciśnij i przytrzymaj przycisk menu na zegarku (lub odpowiedni przycisk na urządzeniach z ekranem dotykowym), aby otworzyć menu systemowe.",
                "select2": "Przejdź do pozycji \"Tarcze\" lub \"Projekty wyświetlacza\".",
                "select3": "Zobaczysz listę wszystkich zainstalowanych tarcz. Użyj przycisków góra/dół lub ekranu dotykowego do nawigacji.",
                "select4": "Potwierdź wybraną tarczę przyciskiem w prawym górnym rogu. Tarcza jest teraz aktywna na zegarku."
            },
            "versions": {
                "title": "VX a Elite – jaka jest różnica?",
                "sameFeatures": "Technicznie obie wersje są identyczne i oferują te same funkcje. Jedyna różnica to sposób zakupu i aktywacji.",
                "eliteTitle": "Wersja Elite (Garmin Pay)",
                "elite1": "Osobna instalacja tarczy zakupionej bezpośrednio przez Garmin Pay w Sklepie ConnectIQ.",
                "elite2": "Wersja Elite jest powiązana z kontem Garmin. Przy nowym zegarku możesz ponownie zainstalować tarczę Elite bez dodatkowego klucza.",
                "elite3": "Garmin Pay nie jest obsługiwane na wszystkich modelach i może być niedostępne w niektórych krajach.",
                "eliteNoKey": "Ważne: Przy zakupie wersji Elite przez Garmin Pay nie jest wysyłany kod odblokowania. Wersja Elite jest odblokowywana od razu po zakupie i nie wymaga kodu.",
                "vxTitle": "Wersja VX / ze strony",
                "vx1": "Kompatybilna z większą liczbą urządzeń i często dostępna także gdy Garmin Pay nie jest.",
                "vx2": "Zawiera wbudowany kilkudniowy okres próbny.",
                "vx3": "Po okresie próbnym możesz kupić kod odblokowania na tej stronie, aby trwale odblokować wersję VX (lub funkcje pro).",
                "vx4": "Kod odblokowania jest ważny tylko dla urządzenia, dla którego został kupiony (WatchfaceID).",
                "vx5": "Jeśli zegarek zostanie wymieniony przez Garmin w ramach gwarancji, można wygenerować nowy klucz. W takim przypadku skontaktuj się z pomocą przez formularz kontaktowy."
            },
            "website": {
                "title": "Zakup przez stronę (wersje VX / zwykłe)",
                "step1": "Najpierw zainstaluj tarczę na zegarku (patrz zakładka Instalacja). WatchfaceID pojawia się w ustawieniach tarczy dopiero po instalacji.",
                "step2": "Otwórz ustawienia tarczy (przez aplikację ConnectIQ lub Garmin Express) i skopiuj WatchfaceID z górnego pola.",
                "step3": "Na tej stronie wybierz odpowiednią tarczę i wpisz WatchfaceID w formularzu zakupu.",
                "step4": "Dokończ płatność. Otrzymasz kod odblokowania e-mailem i możesz go wpisać w pole klucza w ustawieniach tarczy.",
                "noteNoAutoInstall": "Ważne: Zakup kodu odblokowania przez stronę nie instaluje automatycznie tarczy na zegarku. Kroki instalacji powyżej należy wykonać ręcznie."
            },
            "troubleshooting": {
                "installationTitle": "Problemy z instalacją (kolejka / zatrzymane aktualizacje)",
                "installationIntro": "Czasami instalacja się nie udaje, tarcza długo zostaje w kolejce lub aplikacja ConnectIQ zgłasza nieskończone aktualizacje.",
                "installationCause": "Zwykle wiąże się to z aplikacją ConnectIQ lub usługami Garmin, a nie z samą tarczą.",
                "installationFix1": "Zrestartuj zegarek i aplikację ConnectIQ na telefonie.",
                "installationFix2": "Spróbuj instalacji ponownie i upewnij się, że ekran telefonu się nie wyłącza i aplikacja ConnectIQ pozostaje otwarta podczas procesu.",
                "garminPayTitle": "Zakup Garmin Pay utknął w \"w toku\"",
                "garminPayText": "Jeśli zakup Garmin Pay w Sklepie ConnectIQ długo pozostaje w stanie \"w toku\", obsługą zajmuje się wyłącznie Garmin. Jako deweloper nie mamy wpływu na system Garmin Pay. W takim przypadku skontaktuj się z oficjalnym wsparciem Garmin.",
                "noKeyTitle": "Nie otrzymałem klucza odblokowania po zakupie na stronie",
                "noKey1": "Najpierw sprawdź folder spam w skrzynce e-mail. Wiadomości z kluczami często tam trafiają.",
                "noKey2": "Często literówka w adresie e-mail uniemożliwia dostarczenie. Jeśli nie znajdziesz wiadomości, skontaktuj się z nami.",
                "noKey3": "i podaj adres e-mail użyty do płatności oraz ewentualnie WatchfaceID.",
                "noKeyElite": "Uwaga: Przy zakupie wersji Elite bezpośrednio przez Garmin Pay w Sklepie ConnectIQ nie jest wysyłany kod odblokowania. Wersja Elite jest odblokowywana od razu po zakupie i nie wymaga kodu."
            },
            "contactLink": "Formularz kontaktowy"
        },
        "timezones": {
            "title": "Strefy czasowe i przesunięcie UTC",
            "basicsTitle": "Co to są 2. i 3. strefa czasowa?",
            "basicsText": "W wielu tarczach można ustawić dwie dodatkowe strefy czasowe. Nazywają się zwykle \"Druga strefa czasowa\" i \"Trzecia strefa czasowa\" i są wyświetlane w dedykowanych polach na tarczy.",
            "offsetTitle": "Konfiguracja przesunięć UTC",
            "offsetIntro": "W ustawieniach tarczy jest zwykle pole, w którym można wpisać przesunięcia drugiej i trzeciej strefy czasowej w minutach względem UTC.",
            "offsetFormat": "Pierwsza wartość to przesunięcie drugiej strefy, druga – trzeciej. Wartości podaje się w minutach, oddzielone spacją. Znak + nie jest dodawany automatycznie, więc wartości dodatnie wpisuje się bez +.",
            "exampleLabel": "Przykład:",
            "exampleExplanation": "Tutaj druga strefa ma przesunięcie -4,5 h (−270 min), a trzecia +2 h (+120 min), zawsze względem UTC.",
            "changeExample": "Jeśli chcesz ustawić drugą strefę na +6 h, pierwsza wartość musi być 360 (6 × 60). Przy powyższym przykładzie dałoby to:",
            "advancedTitle": "Opcje zaawansowane (sufiks A/B/C)",
            "advancedOptionalHint": "Ta sekcja jest opcjonalna. Dotyczy tylko tarcz obsługujących sufiksy A/B/C.",
            "advancedIntro": "Czy tarcza obsługuje te sufiksy, jest podane w opisie nad polem przesunięcia w ustawieniach tarczy. Jeśli tak, możesz zobaczyć opis w stylu:",
            "advancedExample": "Przesunięcie UTC 2. i 3. strefy w minutach (oddziel spacją) (litery po przesunięciach: A - format 12h, B - format 24h, C - format wojskowy, puste - standard)",
            "advancedNote": "Te opcjonalne litery (A/B/C) sterują formatem wyświetlania danej strefy w niektórych tarczach. Używaj ich tylko wtedy, gdy opis tarczy je wymienia.",
            "exampleSectionTitle": "Krok po kroku: Przykład dla różnych miast i formatów",
            "exampleIntro": "Poniższy przykład pokazuje, jak ustawić 2. strefę (np. Nowy Jork) i 3. (np. Tokio) oraz opcjonalnie wyświetlanie 12h lub 24h dla każdej.",
            "exampleStep1Title": "Krok 1: Przesunięcie UTC dla 2. strefy",
            "exampleStep1Text": "Wybierz miasto lub region dla 2. strefy. Przelicz różnicę do UTC na minuty. Np.: Nowy Jork (EST, UTC−5) → −300 min. Wpisz tę wartość jako pierwszą w polu.",
            "exampleStep2Title": "Krok 2: Przesunięcie UTC dla 3. strefy",
            "exampleStep2Text": "To samo dla 3. strefy. Np.: Tokio (JST, UTC+9) → 540 min. To druga wartość, oddzielona spacją od pierwszej.",
            "exampleOnlyOffsets": "Jeśli tarcza nie używa sufików A/B/C, gotowe. Wpisz:",
            "exampleStep3Title": "Krok 3: Opcjonalny sufiks formatu (A/B/C)",
            "exampleStep3Optional": "Ten krok jest opcjonalny: możesz pominąć sufiksy nawet gdy tarcza je obsługuje; wtedy używany jest format domyślny. Aby wymusić 12h, 24h lub wojskowy dla strefy, dodaj literę zaraz po przesunięciu — bez spacji.",
            "exampleStep3Text": "Przykład: format 12h dla Nowego Jorku (A) i 24h dla Tokio (B):",
            "exampleStep3Note": "Bez sufiksu = domyślny format tarczy (często 24h). Czy sufiksy są obsługiwane, podaje opis nad polem przesunięcia w ustawieniach tarczy.",
            "exampleFormatTitle": "Jak wyświetlany jest czas z A, B, C",
            "exampleFormatIntro": "Dla tego samego momentu wyświetlanie zależy od formatu (np. 2. strefa Nowy Jork -300, 3. strefa Tokio 540). Podgląd na żywo:",
            "zone2": "2. strefa",
            "zone3": "3. strefa",
            "exampleTableTitle": "Odnośnik: Przesunięcia UTC dla wybranych miast (minuty)",
            "exampleTableIntro": "Czas standardowy; czas letni może się różnić. Pomnóż godziny przez 60."
        },
        "switchViews": {
            "title": "Widoki przełączane i sterowanie gestami",
            "wordLabel": "widok przełączany",
            "basicsTitle": "Co to są widoki przełączane?",
            "basicsText": "Wiele tarcz może pokazywać różne informacje w tym samym obszarze ekranu. Te alternatywne strony nazywane są często \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Widok górny 1/2\", \"Widok dolny 1/2\" lub podobnie w ustawieniach.",
            "proNote": "Często te dodatkowe widoki to funkcje pro dostępne w okresie próbnym i wymagające później klucza aktywacji.",
            "gestureTitle": "Przełączanie widoków gestem nadgarstka",
            "gestureIntro": "Na zegarkach bez obsługiwanego ekranu dotykowego widoki można zmieniać drugim ruchem nadgarstka.",
            "gestureStep1": "Unieś nadgarstek jak zwykle, aby obudzić ekran. Sekundy lub podświetlony ekran oznaczają tryb aktywny.",
            "gestureStep2": "W ciągu kilku sekund (ok. 7) wykonaj ponownie ruch nadgarstkiem – nie za gwałtownie, ale wyraźnie, żeby zegarek go rozpoznał.",
            "gestureStep3": "Jeśli tarcza obsługuje widoki przełączane, skonfigurowane obszary (np. widok górny/dolny) przełączą się na następną stronę.",
            "gestureHint": "Jeśli nic się nie zmienia, sprawdź ustawienia: niektóre widoki trzeba jawnie przypisać (np. \"Widok górny 2\" / \"Widok dolny 2\").",
            "touchTitle": "Widoki przełączane na urządzeniach z ekranem dotykowym",
            "touchIntro": "Na nowszych zegarkach z obsługiwanym ekranem dotykowym (np. Fenix 7 i nowsze) widoki często można też zmieniać przez naciśnięcie określonych stref.",
            "touchConfig": "W wielu tarczach te strefy można skonfigurować w ustawieniach, często niżej. Typowe przykłady to cyfry godziny i minuty lub oddzielne obszary na ekranie.",
            "touchHold": "Jeśli strefa dotykowa jest skonfigurowana, długie naciśnięcie odpowiedniej cyfry/obszaru przełącza przypisany widok.",
            "touchMultiple": "Niektóre tarcze mają kilka stref przypisywanych osobno – np. jedną dla widoku górnego i jedną dla dolnego.",
            "touchInfo": "Jeśli tarcza ma specjalne strefy, są one zwykle opisane w tekście informacyjnym na tej stronie lub w Sklepie ConnectIQ."
        },
        "findWfId": {
            "title": "Jak znaleźć WatchfaceID",
            "whatIs": "Co to jest WatchfaceID?",
            "whatIsExplanation": "Każda tarcza ma indywidualny WatchfaceID na urządzenie. To 5–6-cyfrowy numer. Ten ID jest potrzebny do zakupu kodu aktywacji lub do pomocy technicznej.",
            "connectIqTitle": "Przez aplikację ConnectIQ (zalecane)",
            "ciq1": "Upewnij się, że zegarek jest połączony z telefonem przez Bluetooth.",
            "ciq2": "Otwórz aplikację ConnectIQ na telefonie.",
            "ciq3": "Przejdź do strony tarczy z opisem i zdjęciami. Jeśli jej nie znajdziesz, użyj paska \"Szukaj\" na dole lub zajrzyj w \"Moje tarcze\" w sekcji \"Urządzenie\".",
            "ciq4": "Naciśnij przycisk \"Ustawienia\" na stronie tarczy, aby otworzyć wszystkie ustawienia.",
            "ciq5": "WatchfaceID jest w górnym polu. Skopiuj lub wpisz ten numer – to ID potrzebne do płatności.",
            "keyEntryTitle": "Wprowadzanie klucza aktywacji",
            "keyEntryExplanation": "W wierszu pod polem WatchfaceID jest pole na klucz/kod wysyłany po płatności. Niektóre tarcze pokazują tam pozostałe dni próby – usuń to przed wpisaniem klucza.",
            "garminExpressTitle": "Przez Garmin Express (komputer)",
            "ge1": "Zainstaluj Garmin Express i połącz zegarek z komputerem.",
            "ge2": "Przejdź do listy zainstalowanych tarcz.",
            "ge3": "Kliknij przycisk z trzema kropkami przy tarczy, aby otworzyć ustawienia.",
            "ge4": "Wykonaj te same kroki co w aplikacji ConnectIQ.",
            "geNote": "Uwaga: Zalecana jest aplikacja ConnectIQ, ponieważ niektóre wersje Garmin Express mogą powodować błędy.",
            "zeroId": "WatchfaceID pokazuje 0?",
            "zeroIdExplanation": "Czasami WatchfaceID pokazuje 0. Zwykle pomaga jednorazowe zapisanie ustawień lub restart zegarka. Jeśli nadal pokazuje 0, płatność i tak powinna działać."
        },
        "location": {
            "title": "Konfiguracja GPS i lokalizacji",
            "whatIsGpsFix": "Co to jest fix GPS?",
            "gpsFixExplanation": "Fix GPS informuje tarczę, gdzie jesteś, dzięki czemu może poprawnie obliczyć czasy wschodu/zachodu słońca, fazy księżyca, lokalizację pogody i pływy.",
            "howTo": "Jak wykonać fix GPS",
            "step1": "Na zegarku przejdź do ekranu startowego dowolnej aktywności (np. \"Bieganie\")",
            "step2": "Poczekaj, aż zegarek złapie sygnał GPS (zielony pasek/ikona)",
            "step3": "Wróć do tarczy – dane powinny zaktualizować się w ciągu kilku minut",
            "alternative": "Alternatywa: GPS telefonu",
            "alternativeExplanation": "Możesz też włączyć GPS w telefonie. Zegarek musi być połączony przez Bluetooth. Metoda jest wolniejsza, ale działa tak samo.",
            "requirements": "Wymagania",
            "req1": "Zegarek połączony z telefonem przez Bluetooth",
            "req2": "Aplikacja Garmin Connect (nie ConnectIQ) działa przynajmniej w tle",
            "req3": "GPS włączony w telefonie przy lokalizacji z telefonu"
        },
        "settings": {
            "tabs": { "options": "Opcje pól danych", "change": "Zmień ustawienia", "troubleshoot": "Rozwiązywanie problemów" },
            "title": "Ustawienia watchface",
            "optionsIntro": "Ogólna lista opcji pól danych. Kliknij, aby zobaczyć opis. Nie wszystkie opcje są dostępne we wszystkich watchface.",
            "change": {
                "title": "Jak zmienić ustawienia watchface",
                "intro": "Ustawienia watchface zmienia się w aplikacji ConnectIQ na telefonie.",
                "step1": "Połącz zegarek z telefonem przez Bluetooth i otwórz aplikację ConnectIQ (nie Connect).",
                "step2": "Przejdź do strony watchface. Jeśli nie jest zainstalowany, zainstaluj go najpierw.",
                "step3": "Na stronie watchface znajdziesz przycisk „Ustawienia” – dotknij, aby otworzyć listę.",
                "step4": "Tutaj możesz zmienić wszystkie pola danych, kolory i opcje zaawansowane.",
                "step5": "Dotknij przycisku zapisu w prawym górnym rogu, aby przenieść ustawienia na zegarek.",
                "installLink": "Instrukcja instalacji"
            },
            "troubleshoot": {
                "title": "Rozwiązywanie problemów",
                "cantSave": { "q": "Ustawienia nie można zapisać", "a1": "Czasami serwery Garmin mają problemy z niektórymi znakami.", "a2": "Wyczyść pole schematu kolorów (jeśli jest) i zapisz ponownie." },
                "wontOpen": { "q": "Ustawienia się nie otwierają", "a1": "Całkowicie zamknij aplikację ConnectIQ i w razie potrzeby zrestartuj zegarek.", "a2": "Jeśli widzisz tylko przycisk „Zainstaluj”, watchface nie jest jeszcze zainstalowany." },
                "missingOptions": { "q": "Nie mogę znaleźć opcji ustawienia", "a": "Nie wszystkie opcje są dostępne na wszystkich urządzeniach." },
                "naValue": { "q": "Pole pokazuje tylko „n/a”", "a": "Twoje urządzenie nie obsługuje tej opcji (starszy model lub brakujący sprzęt)." }
            }
        },
        "dateFormat": {
            "title": "Niestandardowy format daty (Data 1 / 2 / 3)",
            "basicsTitle": "Do czego służą pola formatu daty?",
            "basicsIntro": "W ustawieniach watchface są dwa pola (lub trzy), w których można skonfigurować wyświetlanie Daty 1, Daty 2 i ewentualnie Daty 3. Wprowadzane litery określają format.",
            "notAll": "Nie dostępne we wszystkich watchface.",
            "where": "Pola zwykle znajdują się niżej w ustawieniach, pod opcjami pól danych.",
            "codesTitle": "Kody formatu",
            "codesIntro": "Możesz użyć następujących liter. Wynik odzwierciedla bieżącą datę.",
            "codeD": "dzień miesiąca (z zerem wiodącym)",
            "codeDText": "dzień jako tekst (np. poniedziałek)",
            "codeM": "miesiąc w liczbie (z zerem wiodącym)",
            "codeMText": "miesiąc jako tekst",
            "codeY": "rok dwucyfrowy",
            "codeY4": "rok czterocyfrowy",
            "codeJ": "data juliańska (wojskowa)",
            "codeW": "numer tygodnia",
            "codeO": "miesiąc bez zera wiodącego",
            "codeN": "dzień bez zera wiodącego",
            "codeP": "dzień roku",
            "exampleHint": "Np. „D, d.M.Y” może wyświetlać „Pon, 27.02.2026”."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Jak działają motywy?:",
            "description": "U góry ustawień tarczy masz \"ciąg motywu\", który reprezentuje aktualne ustawienia kolorów (ikony, wykres, czas itd.). Jeśli coś zmienisz (np. kolor górnej sekcji) i naciśniesz \"Zapisz\", ciąg motywu zaktualizuje się przy następnym otwarciu ustawień. W ten sposób możesz zapisać ustawienia kolorów, kopiując i przechowując ciąg gdzie indziej. Możesz go nawet udostępnić innym (np. w recenzjach/forum) i zastosować ciąg innych osób, aby wypróbować inne style."
        },
        "dynamicThemeSwitching": {
            "title": "Dynamiczna zmiana motywu:",
            "sunset": {
                "title": "Zmiana po zachodzie słońca / przed wschodem -",
                "description": "jeśli w polu ciągu motywu wpiszesz wykrzyknik ! przed ciągiem, na który chcesz przełączyć, zostanie zapisany jako motyw po zachodzie słońca (przykład: !UEUE[UEUEEEEEEU^). Możesz to zmienić w dowolnym momencie, wpisując ciąg z ! na początku. Aby usunąć motyw nocny, wpisz w polu tylko ! i przełączanie się zatrzyma."
            },
            "lowPower": {
                "title": "Zmiana w trybie oszczędzania -",
                "description": "proces jest taki sam jak ustawianie motywu zachód/wschód powyżej, zamiast ! wpisz # przed ciągiem motywu (przykład: #UEUE[UEUEEEEEEU^). Każdy zegarek przechodzi w \"Tryb oszczędzania\" po ok. 10 sekundach patrzenia na zegarek lub powrotu z menu. Zazwyczaj sekundy znikają w trybie oszczędzania (można to zmienić w ustawieniach tarczy). Obie opcje (@noc/@oszczędzanie) można łączyć. Po ustawieniu dynamiczny ciąg motywu nie jest widoczny w ustawieniach tarczy, więc zapisz go gdzie indziej, jeśli chcesz coś zmienić w przyszłości."
            }
        }
    },
    "helpCenter": {
        "title": "Pomoc i instrukcje",
        "subtitle": "Odpowiedzi, przewodniki i instrukcje do twojego watchface",
        "guidesTitle": "Przewodniki i instrukcje",
        "faqTitle": "Często zadawane pytania",
        "allCategories": "Wszystkie",
        "guides": "Przewodniki",
        "faqResults": "FAQ",
        "noResults": "Nie znaleziono wyników",
        "noResultsHint": "Spróbuj innych słów kluczowych lub przeglądaj kategorie i przewodniki poniżej."
    },
    "watchfacesOverview": {
        "title": "Wszystkie aplikacje",
        "loading": "Ładowanie watchfaces...",
        "error": "Błąd ładowania watchfaces",
        "retry": "Spróbuj ponownie",
        "noWatchfaces": "Brak dostępnych watchfaces"
    },
    "detailTabs": {
        "payment": "Płatność",
        "themes": "Motyw",
        "info": "Info",
        "instructions": "Instrukcje",
        "instructionsIntro": "Wszystkie przewodniki i instrukcje w jednym miejscu:",
        "noThemes": "Brak motywów kolorów dla tego watchface."
    },
    "watchfaceDetail": {
        "loading": "Ładowanie watchface...",
        "error": {
            "notFound": "Nie znaleziono watchface",
            "loading": "Błąd ładowania watchface"
        },
        "backToOverview": "Powrót do przeglądu",
        "goToStore": "Przejdź do IQ Store",
        "goToTrial": "Wersja próbna",
        "devices": "urządzenia",
        "info": {
            "title": "Funkcje",
            "tides": "🌊 Informacje o pływach z automatycznymi aktualizacjami",
            "weather": "🌤️ Dane pogodowe z OpenWeatherMap i Yr",
            "colors": "🎨 Motywy kolorów i dostosowania",
            "location": "📍 Lokalizacja przez GPS",
            "faq": "❓ FAQ i wsparcie",
            "weatherFallback": "Bez subskrypcji One Call 3.0 klucz API OpenWeatherMap używa dostawcy \"Yr\" jako zapasowego."
        }
    },
    "colorThemes": {
        "clickToCopy": "Kliknij, aby skopiować",
        "clickToPreview": "Kliknij, aby podgląd",
        "closePreview": "Zamknij podgląd",
        "copied": "Skopiowano!",
        "useInSettings": "Użyj w ustawieniach watchface",
        "guideLink": "Więcej o motywach i ciągach motywów",
        "deviceNote": "Motywy kolorów nie są dostępne na wszystkich urządzeniach.",
        "noFieldNote": "Jeśli ustawienia watchface'a nie mają osobnego pola na schematy kolorów, oznacza to, że nie są one obsługiwane dla Twojego modelu zegarka na tym watchface."
    },
    "payment": {
        "option1": {
            "title": "Opcja 1: Garmin Pay",
            "description": "Kup płatny watchface przez Garmin Pay w ConnectIQ Store (jeśli zegarek jest obsługiwany).",
            "link": "Link do ConnectIQ Store"
        },
        "option2": {
            "title": "Opcja 2: Płatność bezpośrednia przez WatchfaceID",
            "description": "Jeśli zegarek nie jest obsługiwany przez wersję Pro, możesz kupić klucz Trial/VX, podając WatchfaceID.",
            "vxNote": "To jest klucz do wersji VX watchface, nie wersji Garmin Pay!",
            "vxLink": "Link do wersji VX"
        },
        "tax": "VAT",
        "wfid": {
            "description": "Wpisz WatchfaceID (w ustawieniach watchface)",
            "placeholder": "Wpisz WatchfaceID (5-6 cyfr)",
            "guideLink": "Jak znaleźć WatchfaceID",
            "guideLinkShort": "Pokaż instrukcje"
        },
        "wfidError": {
            "letters": "WatchfaceID powinna zawierać tylko cyfry",
            "tooLong": "WatchfaceID powinna mieć 5-6 cyfr",
            "invalid": "Wpisz prawidłową WatchfaceID (5-6 cyfr)",
            "lengthHint": "WatchfaceID ma zwykle 5-6 cyfr. Sprawdź."
        },
        "errors": {
            "empty": "Wpisz WatchfaceID",
            "invalid": "Wpisz prawidłową WatchfaceID",
            "config": "Błąd konfiguracji płatności",
            "checkout": "Nie udało się otworzyć płatności. Spróbuj ponownie."
        },
        "buy": "Kup teraz",
        "selectMethod": "Wybierz swoją wersję",
        "versionSelectHint": "To są dwie oddzielne wersje — wybierz właściwą:",
        "vxWarning": "Wersje VX i Elite to oddzielnie pobierane wersje tarczy zegarka. Kod aktywacyjny dla wersji VX NIE odblokowuje wersji Elite.",
        "beta": {
            "title": "Obecnie w wersji beta",
            "description": "W trakcie tej fazy beta możesz korzystać z tego watchface’a całkowicie za darmo. Po zakończeniu okresu testowego nie zostaną naliczone żadne automatyczne opłaty. W tym czasie testowane są nowe funkcje i ulepszenia. Dziękujemy za Twój feedback!",
            "descriptionApp": "W tej fazie beta możesz korzystać z aplikacji całkowicie za darmo. Po okresie testowym nie zostaną naliczone żadne automatyczne opłaty. W tym czasie testowane są nowe funkcje. Dziękujemy za waszą opinię!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Wersja Elite",
            "description": "Ten watchface jest dostępny tylko przez Garmin Pay w ConnectIQ Store.",
            "comboDescription": "Kup przez Garmin Pay w ConnectIQ Store. Osobna, samodzielna wersja.",
            "compatibility": "Garmin Pay nie jest obsługiwany na wszystkich zegarkach. Sprawdź zgodność na stronie Store. W przeciwnym razie pobierz wersję VX (technicznie identyczna).",
            "storeLink": "Otwórz w ConnectIQ Store",
            "moreGuide": "Więcej o różnicy Elite / VX?",
            "moreGuideLink": "Przeczytaj przewodnik zakupu i instalacji",
            "eliteNoKey": "Przy zakupie wersji Elite przez Garmin Pay nie jest wysyłany żaden kod odblokowania. Wersja Elite jest odblokowana bezpośrednio po zakupie i nie wymaga kodu.",
            "accountBound": "Zakup przez Garmin Pay jest powiązany z Twoim kontem Garmin i automatycznie dostępny dla Twoich przyszłych urządzeń (jeśli kompatybilne).",
            "eliteNoKeyAndGuide": "Przy zakupie przez Garmin Pay nie jest wysyłany kod — wersja Elite jest odblokowana bezpośrednio po zakupie. Więcej szczegółów w przewodniku zakupu i instalacji."
        },
        "vx": {
            "badge": "Wszystkie urządzenia",
            "title": "Wersja VX",
            "description": "Zgodna ze wszystkimi obsługiwanymi urządzeniami. Pobierz wersję próbną z ConnectIQ Store i aktywuj tutaj kupionym kodem.",
            "trialNote": "Wersja VX zawiera okres próbny. Potem kup kod aktywacyjny poniżej, aby odblokować.",
            "deviceBound": "Kod aktywacyjny jest powiązany z Twoim urządzeniem i odblokowuje wersję VX na stałe.",
            "moreGuide": "Więcej o wersji VX, kluczach lub instalacji?",
            "moreGuideLink": "Przeczytaj przewodnik zakupu i instalacji",
            "downloadLink": "Pobierz wersję VX",
            "details": {
                "line1": "Po płatności klucz aktywacyjny zostanie wysłany na adres e-mail podany w następnym kroku.",
                "line2": "Upewnij się, że adres e-mail jest poprawny.",
                "line3": "Sprawdź folder spam po płatności – e-maile z kluczami często tam trafiają.",
                "line4": "Wszystkie płatności obsługuje Paddle; konto nie jest wymagane.",
                "line5": "W sprawie wsparcia użyj formularza kontaktowego lub narzędzia ConnectIQ Store.",
                "line6": "Inne zapytania nie mogą być realizowane."
            }
        },
        "standalone": {
            "title": "Kup kod aktywacyjny",
            "description": "Kup kod aktywacyjny, wpisując poniżej WatchfaceID. Kod zostanie wysłany od razu."
        },
        "checkoutOpening": "Otwieranie płatności...",
        "info": {
            "key": "Po zakupie otrzymasz klucz do wpisania w ustawieniach watchface.",
            "activation": "Klucz jest aktywowany od razu po płatności.",
            "support": "W razie pytań skontaktuj się z wsparciem.",
            "moreGuide": "Więcej o zakupie i instalacji"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Karta kredytowa"
        }
    },
    "footer": {
        "tagline": "Nowoczesne aplikacje Garmin z zaawansowanymi funkcjami do wszystkich aktywności.",
        "description": "Nowoczesne aplikacje Garmin z zaawansowanymi funkcjami do wszystkich aktywności."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Zapisz się do newslettera, aby otrzymywać informacje o nowych tarczach, funkcjach i promocjach.",
        "frequencyHint": "Około jeden e-mail na dwa miesiące. Wypisanie w dowolnym momencie.",
        "emailPlaceholder": "Twój adres e-mail",
        "subscribe": "Zapisz się",
        "unsubscribe": "Wypisz się",
        "subscribeSuccess": "Zapisano! Sprawdź swoją skrzynkę e-mail.",
        "subscribeError": "Wystąpił błąd. Spróbuj ponownie później.",
        "unsubscribeSuccess": "Wypisano z newslettera.",
        "unsubscribeError": "Wystąpił błąd. Spróbuj ponownie później."
    },
    "contact": {
        "title": "Kontakt",
        "description": "Masz pytanie lub potrzebujesz pomocy? Napisz do mnie wiadomość.",
        "emailLabel": "E-mail",
        "emailPlaceholder": "twoj@email.pl",
        "deviceLabel": "Urządzenie (opcjonalnie)",
        "devicePlaceholder": "np. Fenix 7",
        "watchfaceLabel": "Watchface (opcjonalnie)",
        "watchfacePlaceholder": "np. Horizon",
        "messageLabel": "Wiadomość",
        "messagePlaceholder": "Twoja wiadomość...",
        "send": "Wyślij wiadomość",
        "sendAnother": "Wyślij kolejną wiadomość",
        "successTitle": "Wiadomość wysłana!",
        "successMessage": "Odezwę się tak szybko, jak to będzie możliwe.",
        "error": "Wystąpił błąd. Spróbuj ponownie lub napisz bezpośrednio na dev@orcatec.net.",
        "rateLimit": "Maksymalnie 2 wiadomości na 5 minut. Spróbuj ponownie później.",
        "consentNotice": "Wysyłając formularz, wyrażasz zgodę na przetwarzanie danych zgodnie z moją",
        "guidesIntro": "Jeśli masz pytania dotyczące konkretnych funkcji, odpowiedź może już być w tych poradnikach:",
        "faqIntro": "Wiele tematów jest też opisanych w szczegółowym FAQ:",
        "faqLinkLabel": "Otwórz Pomoc i instrukcje",
        "responseTimeNotice": "Proszę o wyrozumiałość – w okresach większego obciążenia odpowiedź może zająć nawet kilka dni."
    },
    "fonts": {
        "title": "Czcionki",
        "timefonts": "Czcionki czasu",
        "datafonts": "Czcionki danych"
    },
    "common": {
        "loading": "Ładowanie...",
        "error": "Błąd",
        "retry": "Spróbuj ponownie",
        "back": "Wstecz",
        "close": "Zamknij",
        "save": "Zapisz",
        "cancel": "Anuluj",
        "confirm": "Potwierdź",
        "notFound": "404 – Strona nie znaleziona"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Aplikacja Bierwandern pozwala śledzić wędrówkę i uzupełnienia, którymi delektujesz się po drodze. Dodatkowo jest szacunek promili z wykresem (przybliżona ocena) – ale proszę, nie traktuj tego zbyt poważnie!",
        "settingsHint": "Na ekranie startowym naciśnij przycisk menu na zegarku, aby wejść do ustawień (na zegarkach z układem 2 przycisków długo naciśnij ekran dotykowy).",
        "disclaimer": "Obliczanie promili to wyłącznie metryka rozrywkowa – algorytm szacujący alkohol we krwi na podstawie spożytych napojów i masy ciała! Nie podejmuj decyzji na podstawie tej wartości – nie jest wiarygodna i nie stanowi prawdziwego pomiaru alkoholu!",
        "closing": "Poza tym życzę Ci udanych wędrówek i dobrego czasu!",
        "support": "W razie problemów lub sugestii użyj przycisku «App Support» – dziękuję."
    },
    "bodysurf": {
        "intro": {
            "title": "Czym jest BodySurf?",
            "text": "BodySurf to aplikacja Garmin Connect IQ do bodysurfingu. Używa GPS do wykrywania jazdy na fali, mierzy dystans i czas każdej jazdy oraz nadaje zabawny tytuł według przebytej odległości. Sesje zapisywane są jako aktywności z osobnymi okrążeniami w Garmin Connect."
        },
        "gps": {
            "title": "Przed startem – GPS",
            "text1": "Poczekaj na fix GPS przed rozpoczęciem sesji. Na ekranie startowym zobaczysz „Szukam GPS”, a po uzyskaniu sygnału „START, aby rozpocząć”.",
            "text2": "Dla najlepszej dokładności aplikacja używa multi-GNSS / dual-band GPS, jeśli zegarek to obsługuje. Stań chwilę nieruchomo przy wodzie, jeśli fix trwa dłużej."
        },
        "start": {
            "title": "Ekran startowy",
            "startBtn": "Rozpocznij nową sesję, gdy GPS jest gotowy (START = rozpocznij sesję).",
            "menuBtn": "Otwórz ustawienia: Jak używać i Jednostki (MENU = ustawienia / informacje).",
            "backBtn": "BACK = wyjdź z aplikacji"
        },
        "during": {
            "title": "Podczas aktywności",
            "detect": "Jazdy są wykrywane przez GPS prędkość automatycznie. Użyj BACK aby ręcznie rozpocząć/zatrzymać jazdę. Krótkie ruchy poniżej ok. 2 metrów są odrzucane.",
            "startBtn": "START = zatrzymaj / zapisz / wznow",
            "backBtn": "BACK = ręczne włączanie/wyłączanie jazdy",
            "live": "Podczas jazdy widzisz aktualny dystans, tytuł na żywo i „JAZDA!”. Po zakończeniu jazdy tytuł i statystyki pozostają do następnej jazdy."
        },
        "stop": {
            "title": "Menu zatrzymania",
            "resume": "Wznów",
            "save": "Zapisz",
            "discard": "Odrzuć"
        },
        "after": {
            "title": "Po sesji",
            "summary": "Podsumowanie pokazuje czas sesji, liczbę Jazdy, całkowity dystans i Najlepszy jazdę z tytułem i statystykami.",
            "rides": "Przesuń, aby zobaczyć szczegóły jazdy. Na zegarkach z przyciskami: << DOWN rides.",
            "finished": "Potem: Nowa sesja przez START lub Wyjdź z aplikacji przez WSTECZ."
        },
        "titles": {
            "title": "Tytuły jazd",
            "intro": "Każda jazda ma zabawny tytuł na podstawie dystansu. Im dłuższa jazda, tym lepszy tytuł!",
            "colDistance": "Dystans",
            "colTitle": "Tytuł",
            "th0": "Dryfujący",
            "th1": "Strzykwa",
            "th2": "Flądra",
            "th3": "Postrach mew",
            "th4": "Szeryf",
            "th5": "Inspektor",
            "th6": "Surfer fal",
            "th7": "Doradca",
            "th8": "Pogromca",
            "th9": "Aquaman",
            "th10": "Ludzka deska surfingowa",
            "th11": "Legenda wybrzeża",
            "th12": "Posejdon"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Zapisane sesje pojawiają się w Garmin Connect z polami: tytuł jazdy, dystans okrążenia (metry), czas okrążenia (sekundy) oraz najdłuższa jazda/czas na poziomie sesji. Każda wykryta jazda jest zapisana jako okrążenie."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Na Instinct subdisplay pokazuje czas, GPS i dystans. Użyj przycisku DÓŁ zamiast przesuwania (<< DOWN rides).",
            "menu": "„Menu” jest po lewej na ekranie startowym. Naciśnij START, gdy w subdisplay pojawi się GPS OK."
        },
        "settings": {
            "title": "Ustawienia",
            "units": "Jednostki: przełącz między metrycznym a imperialnym dla dystansu i prędkości.",
            "info": "Informacje: pomoc w zegarku (Jak używać) dla przycisków podczas aktywności, po sesji i na ekranie startowym."
        },
        "supportBefore": "W razie problemów lub sugestii skorzystaj z",
        "supportLink": "formularza kontaktowego",
        "supportAfter": " – dziękujemy!"
    }
};
